import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Spacer from '../spacer';
import Text from '../text';
import Button from '../button';
import useMobile from '../hooks/use-mobile';
import Modal from './modal';
const StyledContainer = styled.View`
  padding: ${props => props.mobile ? 20 : 24}px;
`;
export default function Input(props) {
  const mobile = useMobile();
  return /*#__PURE__*/React.createElement(Modal, {
    active: props.active,
    activeSetter: props.activeSetter,
    width: mobile ? 300 : 327
  }, /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile
  }, /*#__PURE__*/React.createElement(Text.H6, null, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "d16",
    height: true
  }), props.children, /*#__PURE__*/React.createElement(Spacer, {
    size: "d32",
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    onPress: props.onPress,
    disabled: props.buttonDisabled,
    width: "100%"
  }, props.buttonName), props.backBtn && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    onPress: () => props.activeSetter(false),
    type: "tertiary"
  }, "Back"))));
}
Input.defaultProps = {
  title: '',
  children: null,
  buttonName: '',
  buttonDisabled: false,
  onPress: () => {},
  active: false,
  backBtn: false
};
Input.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  buttonName: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  onPress: PropTypes.func,
  active: PropTypes.bool,
  activeSetter: PropTypes.func.isRequired,
  backBtn: PropTypes.bool
};
//# sourceMappingURL=input.js.map